/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Homepage_Features_Upload_WordInputs */

const en_homepage_features_upload_word = /** @type {(inputs: Homepage_Features_Upload_WordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Word Docs`)
};

const es_homepage_features_upload_word = /** @type {(inputs: Homepage_Features_Upload_WordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documentos Word`)
};

/**
* | output |
* | --- |
* | "Word Docs" |
*
* @param {Homepage_Features_Upload_WordInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const homepage_features_upload_word = /** @type {((inputs?: Homepage_Features_Upload_WordInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Homepage_Features_Upload_WordInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_homepage_features_upload_word(inputs)
	return en_homepage_features_upload_word(inputs)
});